import i18n from 'i18next';

export const RECAPTCHA_ENTERPRISE_SITE_KEY = '6Lcb834sAAAAAL1-CyJMwGuP_J-Ml1yIlsWaye6F';
export const TENCENT_CAPTCHA_APP_ID = 189959233;

export function shouldUseTencentCaptcha(country: string) {
  return country === 'cn' || i18n.language === 'zh';
}
